import { round } from "./units"

export const parseCurrency = (value: string) => {
  return parseFloat(value.replace(/[^0-9-.]/g, ""))
}

export const formatCurrency = (
  amount: number | undefined | null,
  options?: Partial<
    Intl.NumberFormatOptions & {
      locale: Intl.LocalesArgument
    }
  >,
) => {
  const {
    locale,
    currency,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    ...restOptions
  } = options || {}
  const formatAmount = amount || 0
  return formatAmount.toLocaleString(locale ?? "en-US", {
    style: "currency",
    currency: currency || "USD",
    // Ensure that minimumFractionDigits <= maximumFractionDigits (Edge & Safari)
    // @see https://stackoverflow.com/a/41045289/2270233
    minimumFractionDigits:
      minimumFractionDigits <= maximumFractionDigits
        ? minimumFractionDigits
        : maximumFractionDigits,
    maximumFractionDigits,
    ...restOptions,
  })
}

export const calculateRefundAmounts = (params: {
  productPrice: number
  quantityToRefund: number
  sampleDiscountApplied: boolean
  sampleDiscountPercent: number
  shippingCostToRefund?: number
  fulfillmentFeeToRefund?: number
}): {
  subtotalRefundAmount: number
  totalRefundAmount: number
} => {
  const {
    productPrice,
    quantityToRefund,
    sampleDiscountApplied,
    sampleDiscountPercent,
    shippingCostToRefund = 0,
    fulfillmentFeeToRefund = 0,
  } = params

  const subtotal = productPrice * quantityToRefund
  const discount = sampleDiscountApplied
    ? round(subtotal * (sampleDiscountPercent / 100))
    : 0

  const subtotalRefundAmount = subtotal - discount

  return {
    subtotalRefundAmount,
    totalRefundAmount:
      subtotalRefundAmount + shippingCostToRefund + fulfillmentFeeToRefund,
  }
}
